/*
* Creates a locally generated menu, useful for dynamic content from APIs.
*
* Note, limit use of this to debug menus until IE8 is no longer supported. (Or add IE8 support)
* TODO: Resizing properly like the old dialog.
*/
define('dialogv2',['utils/dom_helper', 'utils/constants'], function(DomHelper, CONST) {
  var Dialog = {
    iframe: null,
    mask: null,
    loaded: false,
    loadedCallback: null,
    width: 0,
    height: 0,

    create: function(body, width, height) {
      if (this.iframe) {
        this.destroy();
      }

      var iframe = document.createElement('iframe');
      this.iframe = iframe;
      iframe.setAttribute('style', 'position: absolute; z-index: 10000; border: 0;');
      iframe.style.width = width + 'px';
      iframe.style.height = height + 'px';
      this.width = width;
      this.height = height;
      var html = '<html>' +
      '<head>' +
      '<link rel="stylesheet" href="' + CONST.cdnUrl + '/dialogv2/default.css' + '">' +
      '</head>' +
      '<body>' + body + '</body></html>';

      var mask = document.createElement('div');
      this.mask = mask;
      mask.setAttribute('style', 'position: absolute; z-index: 9999; border: 0; top: 0; left: 0;');
      mask.style.background = 'rgba(0, 0, 0, 0.5)';
      mask.style.width = '100%';
      mask.style.height = '100%';
      mask.appendChild(iframe);
      document.body.appendChild(mask);
      iframe.contentWindow.document.open();
      iframe.contentWindow.document.write(html);
      iframe.contentWindow.document.close();
      this.center();

      iframe.onload = function() {
        Dialog.loaded = true;
        if (Dialog.loadedCallback) {
          Dialog.loadedCallback();
        }
      };

      DomHelper.addEventListener(window, 'resize', Dialog.center);
    },

    destroy: function() {
      if (!this.iframe) {
        return;
      }

      DomHelper.removeEventListener(window, 'resize', Dialog.center);
      document.body.removeChild(this.mask);
      this.iframe = null;
      this.mask = null;
      this.loaded = false;
      this.loadedCallback = null;
      window.focus();
    },

    center: function() {
      var w = window;
      var d = document;
      var e = d.documentElement;
      var g = d.getElementsByTagName('body')[0];
      var width = w.innerWidth || e.clientWidth || g.clientWidth;
      var height = w.innerHeight || e.clientHeight || g.clientHeight;

      //this.sizeMask(dialog, width, height);
      //this.sizeFrame(dialog, width, height);

      var x = (width - Dialog.width) / 2;
      var y = (height - Dialog.height) / 2;
      Dialog.iframe.style.left = x + 'px';
      Dialog.iframe.style.top = y + 'px';
    },

    loadStyle: function(href) {
      if (!Dialog.iframe) {
        return;
      }

      var frameDoc = Dialog.iframe.contentWindow.document;
      for (var i = 0; i < frameDoc.styleSheets.length; i++) {
        if (frameDoc.styleSheets.href == href) {
          return;
        }
      }

      var head  = frameDoc.getElementsByTagName('head')[0];
      var link  = frameDoc.createElement('link');
      link.rel  = 'stylesheet';
      link.type = 'text/css';
      link.href = href;
      head.appendChild(link);
    },

  };

  return Dialog;
});

